import React from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDateLocalNoTime, generalPostFunction } from "../Globals/globalFunctions";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { cardArray, gameCollectionArray, userLevelArray } from "../Globals/globalMetaData";
import { SvgIcon } from "../Components/SvgIcons";

function TurnoverReport() {
	const navigate = useNavigate();
	const locationState = useLocation().state;
	const [agentReport, setAgentReport] = useState([]);
	const [reportDate, setReportDate] = useState({
		startDate: formatDateLocalNoTime(new Date()),
		endDate: formatDateLocalNoTime(new Date()),
	});

	const [dateRangeType, setDateRangeType] = useState("today");
	const setAllPlayers = useSelector((state) => state.allPlayers.setAllPlayers);
	const account = JSON.parse(localStorage.getItem("account"));
	const [gameName, setGameName] = useState("");
	const [commisionpoint, setCommisionpoint] = useState(0);

	const [selectedSuperStockez, setSelectedSuperStockez] = useState("");
	const [selectedStockez, setSelectedStockez] = useState("");
	const [selectedMaster, setSelectedMaster] = useState("");
	const [selectedAgent, setSelectedAgent] = useState("");
	const [selectedPlayer, setSelectedPlayer] = useState("");

	const [accountType, setAccountType] = useState();

	const [selectedUsername, setSelectedUsername] = useState();

	useEffect(() => {
		const today = new Date();
		let startDate = new Date();
		let endDate = new Date(today); // default end date = today

		switch (dateRangeType) {
			case "today":
				startDate = today;
				endDate = today;
				break;

			case "yesterday":
				startDate = new Date(today);
				startDate.setDate(today.getDate() - 1);
				endDate = new Date(startDate); // both start & end = yesterday
				break;

			case "7_days":
				startDate = new Date(today);
				startDate.setDate(today.getDate() - 7);
				endDate = today;
				break;

			case "1_month":
				startDate = new Date(today);
				startDate.setMonth(today.getMonth() - 1);
				endDate = today;
				break;

			case "3_month":
				startDate = new Date(today);
				startDate.setMonth(today.getMonth() - 3);
				endDate = today;
				break;

			case "this_week": {
				const dayOfWeek = today.getDay();
				const daysSinceMonday = (dayOfWeek + 6) % 7;
				startDate = new Date(today);
				startDate.setDate(today.getDate() - daysSinceMonday);
				endDate = today;
				break;
			}

			case "last_week": {
				const dayOfWeek2 = today.getDay();
				const daysSinceMonday2 = (dayOfWeek2 + 6) % 7;

				// Last Monday
				startDate = new Date(today);
				startDate.setDate(today.getDate() - daysSinceMonday2 - 7);

				// Last Sunday
				endDate = new Date(startDate);
				endDate.setDate(startDate.getDate() + 6);
				break;
			}

			case "this_month":
				startDate = new Date(today.getFullYear(), today.getMonth(), 1);
				endDate = today;
				break;

			case "last_month":
				startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
				endDate = new Date(today.getFullYear(), today.getMonth(), 0); // last day of last month
				break;

			default:
				startDate = today;
				endDate = today;
		}

		setReportDate({
			startDate: formatDateLocalNoTime(startDate),
			endDate: formatDateLocalNoTime(endDate),
		});
	}, [dateRangeType]);

	const getReportByDate = async () => {
		try {
			const payload = {
				username: selectedUsername,
				user_id: setAllPlayers.find((item) => item?.username == selectedUsername)?.id,
				level: parseInt(accountType),
				startDate: reportDate.startDate,
				endDate: reportDate.endDate,
				names: gameName,
			};
			if (accountType == 5) {
				const response = await generalPostFunction("/getuserbetdetails_gamewise", payload, "3040");
				if (response.message == "success") {
					if (gameName !== "") {
						const total = response.result[gameName].reduce((sum, item) => sum + (item?.totalbet || 0), 0);
						const win = response.result[gameName].reduce((sum, item) => sum + (item?.winamount || 0), 0);
						const commission = response.result[gameName].reduce((sum, item) => sum + (item?.commission || 0), 0);

						setAgentReport([
							{
								username: selectedUsername,
								level: 5,
								balance: setAllPlayers?.find((item) => item.username == selectedUsername)?.balance || 0,
								total: total,
								winrs: win,
								commission: commission,
							},
						]);
					} else {
						const mergedGames = Object.entries(response.result).flatMap(([gameName, arr]) =>
							arr.map((item) => ({
								...item,
								gamename: gameName,
							})),
						);
						const total = mergedGames.reduce((sum, item) => sum + (item?.totalbet || 0), 0);
						const win = mergedGames.reduce((sum, item) => sum + (item?.winamount || 0), 0);
						const commission = mergedGames.reduce((sum, item) => sum + (item?.commission || 0), 0);

						setAgentReport([
							{
								username: selectedUsername,
								level: 5,
								balance: setAllPlayers?.find((item) => item.username == selectedUsername)?.user_balance || 0,
								total: total,
								winrs: win,
								commission: commission,
							},
						]);
					}

					setCommisionpoint(response.commisionpoint);
				}
			} else {
				const response = await generalPostFunction("/getbetdetails_perheirarchy", payload, "3040");
				if (response.message == "success") {
					setAgentReport(
						response.result.map((item) => ({
							...item,
							balance: item.user_balance,
							total: item.totalbet,
							winrs: item.winamount,
						})),
					);
				}
			}
		} catch (err) {
			console.log(err);
		}
	};

	// useEffect(() => {
	// 	if (selectedPlayer) {
	// 		setSelectedUsername(selectedPlayer);
	// 	} else if (selectedAgent) {
	// 		setSelectedUsername(selectedAgent);
	// 	} else if (selectedMaster) {
	// 		setSelectedUsername(selectedMaster);
	// 	} else if (selectedStockez) {
	// 		setSelectedUsername(selectedStockez);
	// 	} else if (selectedSuperStockez) {
	// 		setSelectedUsername(selectedSuperStockez);
	// 	} else {
	// 		setSelectedUsername("");
	// 	}
	// }, [selectedSuperStockez, selectedStockez, selectedMaster, selectedAgent, selectedPlayer]);
	return (
		<>
			<div className="overviewTableWrapper">
				<div className="overviewTableChild">
					<div className="d-flex flex-wrap">
						<div className="col-12">
							<div className="heading">
								<div className="content">
									<h4>Turnover Report </h4>
								</div>
								<div className="buttonGroup">
									<button className="panelButton gray" onClick={() => navigate(-1)}>
										<span className="text">Back</span>
										<span className="icon">
											<SvgIcon name="back" />
										</span>
									</button>
								</div>
							</div>
						</div>
						<div className="col-12" style={{ overflow: "auto", padding: "10px 20px 0px" }}>
							<div className="tableHeader">
								<div className="d-flex justify-content-xl-end">
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Account Type</label>
										<select className="formItem" value={accountType} onChange={(e) => setAccountType(e.target.value)}>
											<option value={""}>Select Account Type</option>
											{userLevelArray && userLevelArray.length > 0 ? (
												userLevelArray
													.filter((item) => item.level > account.level)
													.map((item, index) => (
														<option key={index} value={item.level}>
															{item.name}
														</option>
													))
											) : (
												<option>No Account Found!</option>
											)}
										</select>
									</div>
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Player</label>
										<select className="formItem" value={selectedUsername} onChange={(e) => setSelectedUsername(e.target.value)}>
											<option value={""}>Select Player</option>
											{setAllPlayers && setAllPlayers.length > 0 ? (
												setAllPlayers
													.filter((item) => item.level == accountType)
													.map((item, index) => (
														<option key={index} value={item.username}>
															{item.username}
														</option>
													))
											) : (
												<option>No Account Found!</option>
											)}
										</select>
									</div>
									{/* <div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Super Stockist</label>
										<select className="formItem" value={selectedSuperStockez} onChange={(e) => setSelectedSuperStockez(e.target.value)}>
											<option value={""}>Select Super Stockist</option>
											{setAllPlayers && setAllPlayers.length > 0 ? (
												setAllPlayers
													.filter((item) => item.owner == account.username && item.level == userLevelArray.find((u) => u.name === "Super Stokist")?.level)
													.map((item, index) => (
														<option key={index} value={item.username}>
															{item.username}
														</option>
													))
											) : (
												<option>No Account Found!</option>
											)}
										</select>
									</div>
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Stockist</label>
										<select className="formItem" value={selectedStockez} onChange={(e) => setSelectedStockez(e.target.value)}>
											<option value={""}>Select Stockist</option>
											{setAllPlayers && setAllPlayers.length > 0 ? (
												setAllPlayers
													.filter((item) => item.owner == selectedSuperStockez && item.level == userLevelArray.find((u) => u.name === "Stokist")?.level)
													.map((item, index) => (
														<option key={index} value={item.username}>
															{item.username}
														</option>
													))
											) : (
												<option>No Account Found!</option>
											)}
										</select>
									</div>
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Master</label>
										<select className="formItem" value={selectedMaster} onChange={(e) => setSelectedMaster(e.target.value)}>
											<option value={""}>Select Master</option>
											{setAllPlayers && setAllPlayers.length > 0 ? (
												setAllPlayers
													.filter((item) => item.owner == selectedStockez && item.level == userLevelArray.find((u) => u.name === "Master")?.level)
													.map((item, index) => (
														<option key={index} value={item.username}>
															{item.username}
														</option>
													))
											) : (
												<option>No Account Found!</option>
											)}
										</select>
									</div>
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Agent</label>
										<select className="formItem" value={selectedAgent} onChange={(e) => setSelectedAgent(e.target.value)}>
											<option value={""}>Select Agent</option>
											{setAllPlayers && setAllPlayers.length > 0 ? (
												setAllPlayers
													.filter((item) => item.owner == selectedMaster && item.level == userLevelArray.find((u) => u.name === "Agent")?.level)
													.map((item, index) => (
														<option key={index} value={item.username}>
															{item.username}
														</option>
													))
											) : (
												<option>No Account Found!</option>
											)}
										</select>
									</div>
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Player</label>
										<select className="formItem" value={selectedPlayer} onChange={(e) => setSelectedPlayer(e.target.value)}>
											<option value={""}>Select Player</option>
											{setAllPlayers && setAllPlayers.length > 0 ? (
												setAllPlayers
													.filter((item) => item.owner == selectedAgent && item.level == userLevelArray.find((u) => u.name === "Player")?.level)
													.map((item, index) => (
														<option key={index} value={item.username}>
															{item.username}
														</option>
													))
											) : (
												<option>No Account Found!</option>
											)}
										</select>
									</div> */}
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Game Name</label>
										<select className="formItem" value={gameName} onChange={(e) => setGameName(e.target.value)}>
											<option value={""}>All Games</option>
											{gameCollectionArray.map((item, index) => (
												<option key={index} value={item.value}>
													{item.label}
												</option>
											))}
										</select>
									</div>
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Date Filter</label>
										<select className="formItem" value={dateRangeType} onChange={(e) => setDateRangeType(e.target.value)}>
											<option value="today">Today</option>
											<option value="yesterday">Yesterday</option>
											{/* <option value="7_days">Last 7 Days</option> */}
											<option value="this_week">This Week</option>
											<option value="last_week">Last Week</option>
											<option value="this_month">This Month</option>
											<option value="last_month">Last Month</option>
											{/* <option value="1_month">Last 1 Month</option> */}
											{/* <option value="3_month">Last 3 Months</option> */}
										</select>
									</div>
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">From Date</label>
										<div className="d-flex w-100">
											<input
												type="date"
												className="formItem"
												value={reportDate.startDate}
												onChange={(e) =>
													setReportDate((prev) => ({
														...prev,
														startDate: formatDateLocalNoTime(new Date(e.target.value)),
													}))
												}
											/>
										</div>
									</div>
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">To Date</label>
										<div className="d-flex w-100">
											<input
												type="date"
												className="formItem"
												value={reportDate.endDate}
												onChange={(e) =>
													setReportDate((prev) => ({
														...prev,
														endDate: formatDateLocalNoTime(new Date(e.target.value)),
													}))
												}
											/>
										</div>
									</div>
									<button type="button" className="panelButton mt-auto mb-2 ms-0" onClick={getReportByDate}>
										<span className="text">Search</span>
										<span className="icon">
											<SvgIcon name="search" />
										</span>
									</button>
								</div>
							</div>
							<div className="tableContainer">
								<table>
									<thead>
										<tr>
											{/* <th style={{ width: "20px" }}>#</th> */}
											<th>USERNAME</th>
											{/* <th>LEVEL</th> */}
											{/* <th>DATE TIME</th> */}
											{/* <th>BARCODE</th> */}
											{/* <th>RESULT</th> */}
											<th>PLAY</th>
											<th>WON</th>
											<th>END POINT</th>
											{/* <th>STATUS</th> */}
											<th>COMM</th>
											<th>NTP</th>
											{agentReport.some((x) => x.user_count) ? <th>DETAILS</th> : ""}
										</tr>
									</thead>
									<tbody>
										{/* {agentReport && agentReport.length > 0 ? (
											agentReport
												.sort((a, b) => b.id - a.id)
												.map((item, index) => {
													const date = new Date(item.betdate);
													const time = new Date(item.bettime);
													const formattedDate = date.toLocaleDateString("en-US", {
														month: "short",
														day: "numeric",
														year: "numeric",
													});
													const formattedTime = time.toLocaleTimeString("en-US", {
														hour: "numeric",
														minute: "2-digit",
														hour12: true,
													});
													const commission = parseFloat(commisionpoint);
													const ntp = (item.winrs - (commission / 100) * item.winrs).toFixed(2);
													const result = cardArray.find((card) => card.nCardId == item.result);
													const ntpPercent = (((item.total - item.winrs) / item.total) * 100).toFixed(2);
													return (
														<tr>
															<td style={{ width: "20px" }}>{index + 1}</td>
															<td>{selectedUsername}</td>
															<td>
																{formattedDate}, {formattedTime}
															</td>
															<td>{item?.barcode}</td>
															<td>
																{gameName === "card12" ? (
																	result ? (
																		<div className="resultBlock">
																			<label>{result?.name?.substring(0, 1)}</label>
																			<img className="ms-1" style={{ width: "15px" }} src={`/assets/images/report/${result?.name?.substring(1)}.png`} />
																		</div>
																	) : (
																		"N/A"
																	)
																) : (
																	<label>{item?.result?.substring(1)}</label>
																)}
															</td>
															<td>{item?.total}</td>
															<td>{item?.winrs || 0}</td>
															<td>{item?.status}</td>
															<td>{commission}%</td>
															<td>{ntpPercent}%</td>
														</tr>
													);
												})
										) : (
											<tr>
												<td colSpan={99} className="text-center">
													No Data Found
												</td>
											</tr>
										)} */}
										{/* {agentReport && agentReport.length > 0 ? (
											(() => {
												const total = agentReport.reduce((sum, item) => sum + (item?.total || 0), 0);
												const win = agentReport.reduce((sum, item) => sum + (item?.winrs || 0), 0);
												const ntpPercent = (((total - win) / total) * 100).toFixed(2);
												return (
													<tr>
														<td>{selectedUsername}</td>
														<td>{agentReport.reduce((sum, item) => sum + (item?.total || 0), 0)}</td>
														<td>{agentReport.reduce((sum, item) => sum + (item?.winrs || 0), 0)}</td>
														<td>{setAllPlayers?.find((item) => item.username == selectedUsername)?.balance || 0}</td>
														<td>{ntpPercent}%</td>
													</tr>
												);
											})()
										) : (
											<tr>
												<td colSpan={99} className="text-center">
													No Data Found
												</td>
											</tr>
										)} */}
										{agentReport && agentReport?.length > 0 ? (
											agentReport?.map((item, key) => {
												const ntp = item.total - item.winrs;
												const ntpPercent = (((item.total - item.winrs) / item.total) * 100).toFixed(2);
												const level = userLevelArray?.find((lvl) => lvl.level == item?.level)?.name;
												console.log(item);

												return (
													<tr key={key}>
														<td>{item?.username}</td>
														{/* <td>{level}</td> */}
														<td>{item?.total}</td>
														<td>{item?.winrs}</td>
														<td>{ntp}</td>
														<td>{item?.commission || item?.totalcommission}</td>
														<td>{isNaN(ntpPercent) ? 0 : ntpPercent} %</td>
														{item.user_count && Object.entries(item.user_count).length > 0 ? (
															<td>
																<div class="dropdown">
																	<button className="tableButton edit" type="button" id={`dropdownMenuButton${key}`} data-bs-toggle="dropdown" aria-expanded="false">
																		<SvgIcon name="info" />
																	</button>
																	<ul class="dropdown-menu" aria-labelledby={`dropdownMenuButton${key}`}>
																		{Object.entries(item.user_count).map(([key, value]) => (
																			<li>
																				<a
																					class="dropdown-item"
																					style={{
																						textTransform: "capitalize",
																					}}
																				>
																					<span>{key}</span>
																					<span>
																						<b>{value?.toString()?.padStart(2, "0")}</b>
																					</span>
																				</a>
																			</li>
																		))}
																	</ul>
																</div>
															</td>
														) : (
															""
														)}
													</tr>
												);
											})
										) : (
											<tr>
												<td colSpan={99} className="text-center">
													No Data Found
												</td>
											</tr>
										)}
										<tr
											style={{
												position: "sticky",
												bottom: "-5px",
												backgroundColor: "#fff",
											}}
										>
											<td></td>
											<td className="fw-bold">TOTAL: {agentReport?.reduce((sum, item) => sum + (item?.total || 0), 0)}</td>
											<td className="fw-bold">WON: {agentReport?.reduce((sum, item) => sum + (item?.winrs || 0), 0)}</td>
											<td className="fw-bold">NTP: {agentReport?.reduce((sum, item) => sum + (item?.total || 0), 0) - agentReport?.reduce((sum, item) => sum + (item?.winrs || 0), 0)}</td>
											<td className="fw-bold">COMM: {agentReport?.reduce((sum, item) => sum + (item?.commission || item?.totalcommission || 0), 0)}</td>
											<td className="fw-bold">
												AVG NTP %:{" "}
												{(
													((agentReport?.reduce((sum, item) => sum + (item?.total || 0), 0) - agentReport?.reduce((sum, item) => sum + (item?.winrs || 0), 0)) /
														agentReport?.reduce((sum, item) => sum + (item?.total || 0), 0)) *
													100
												).toFixed(2)}
											</td>
											{agentReport.some((x) => x.user_count) ? <td></td> : ""}
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default TurnoverReport;
